import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

import { TableRowCell, TableRow } from '../../Table';

const cubicBezier = 'cubic-bezier(0.23, 1, 0.32, 1)';

type Props = {
  selected?: boolean;
};

export const TableRowWrapper = styled(TableRow)<Props>`
  > ${TableRowCell} {
    transition: background-color 0.4s ${cubicBezier};
    padding: 0;
  }

  ${media.lgUp`
    > ${TableRowCell} {
      background-color: ${({ theme, selected }) =>
        selected && theme.color.phantom};
    }
    &:hover {
      > ${TableRowCell} {
        background-color: ${({ theme }) => theme.color.phantom};
      }
    }
  `}
`;

export const SkeletonTableRow = styled(TableRow)`
  > ${TableRowCell} > div {
    position: relative;
    ${media.lgUp`
      display: flex;
      align-items: center;
    `}
  }
`;

export const TooltipLabel = styled('span')`
  ${({ theme }) => theme.typography.tiny}
  color: inherit;
  border-bottom: 1px dotted ${({ theme }) => theme.color.brand01};
  cursor: pointer;
  display: inline-block;
  user-select: none;
`;
